import React from 'react';

export const ArrowDown = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.843258 3.01159C0.642517 2.822 0.326086 2.83103 0.136491 3.03177C-0.0531049 3.23252 -0.0440697 3.54895 0.156671 3.73854L4.65634 7.98839C4.84902 8.17036 5.15021 8.17038 5.3429 7.98842L9.8433 3.73857C10.0441 3.54899 10.0531 3.23256 9.86354 3.0318C9.67396 2.83105 9.35753 2.82199 9.15677 3.01157L4.99967 6.93723L0.843258 3.01159Z" fill="black" fillOpacity="0.75"/>
  </svg>

)
